import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { BalancoFinanceiroOperacaoCategoriaItem } from "core/features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { mapFormaPagamentoToLabel } from "infra/helpers/mapFormaPagamentoToLabel";
import colors from "theme/colors";

interface RelatorioItemProps {
  item: BalancoFinanceiroOperacaoCategoriaItem;
}

function RelatorioItem({ item }: RelatorioItemProps) {
  return (
    <>
      {item.contas.map((conta, contaIdx) => {
        const bg = contaIdx % 2 === 0 ? "white" : colors.black100;

        return (
          <Box key={conta.id}>
            <Box
              key={conta.id}
              as={Row}
              gutter={2}
              py={2}
              display="flex"
              alignItems="center"
              bg={bg}
            >
              <Box key={contaIdx} as={Col} xs={12}>
                <Text fontWeight={"regular"}>
                  <Text fontWeight={"medium"} display="inline">
                    {item.breadcrumb} {item.nome}
                  </Text>{" "}
                  - {conta.descricao}
                </Text>
              </Box>

              <Box as={Col} xs={2}>
                <Text fontWeight={"medium"} textAlign="center">
                  {conta.competencia
                    ? moment(conta.competencia, "YYYY-MM").format("MM/YYYY")
                    : "--"}
                </Text>
              </Box>

              <Box as={Col} xs={3}>
                <Text fontWeight={"medium"} textAlign="center">
                  {moment(conta.dataLiquidacao).format("DD/MM/YYYY")}
                </Text>
              </Box>

              <Box as={Col} xs={3}>
                <Text fontWeight={"medium"} textAlign="center">
                  {mapFormaPagamentoToLabel(conta.formaPagamentoId)}
                </Text>
              </Box>

              <Box as={Col} xs={2}>
                <Text fontWeight={"medium"} textAlign="center">
                  {conta.notaFiscal ?? "--"}
                </Text>
              </Box>

              <Box as={Col} xs={2}>
                <Text fontWeight={"medium"} textAlign="right">
                  {formatMoney(conta.valorReferenteComposicao)}
                </Text>
              </Box>
            </Box>
          </Box>
        );
      })}
    </>
  );
}

export default RelatorioItem;
